var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 129,
    viewBox: "0 0 87 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.6993 23.8627L71.7814 11.9896L83.3344 15.9616L79.2523 27.8347C90.1394 32.9849 99.4168 41.7308 105.113 53.3949C118.435 80.6783 107.118 113.596 79.8349 126.919C52.5516 140.241 19.634 128.924 6.31109 101.641C-7.01172 74.3578 4.30547 41.4401 31.5887 28.1172C43.2528 22.4215 55.9467 21.2293 67.6993 23.8627ZM36.8211 52.7535L52.9032 85.6873L63.8811 80.3266L47.799 47.3928L36.8211 52.7535ZM1.59181 22.3717L45.5036 0.928972L50.8642 11.9069L6.9525 33.3497L1.59181 22.3717Z",
    fill: "#DED2D2",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuration);
export default __webpack_public_path__ + "static/media/duration.92223552fff47b39101d45972be03844.svg";
export { ForwardRef as ReactComponent };